import React, { useEffect, useState } from 'react';
import './index.scss';
import DrugDetailLayout from './drugDetailLayout';
import _ from 'lodash';
import NotFound from '../NotFound/index.jsx';

const DrugDetail = props => {
  let repos;
  if (typeof window !== 'undefined' && typeof __INITIAL_DATA__ !== 'undefined')
    repos = window.__INITIAL_DATA__;
  else repos = props.staticContext.data;
  let initialState = {
    repos,
    sectionList: [
      'Overview',
      'Uses',
      'Forms',
      'Dosage',
      'Images',
      'Directions',
      'Missed a dose',
      'Contraindications',
      'Warnings',
      'Interactions',
      'Side effects',
      'Related drugs',
      'Related conditions',
      'Research'
    ],
    drugSectionList: []
  };
  const [data, setData] = useState(initialState);

  useEffect(() => {
    if (data?.repos) {
      setSections(
        repos?.replaceableVariables?.description,
        repos?.blogData,
        repos?.cmsData,
        repos?.imageData,
        repos?.drugStructure?.isNormalDrug
      );
    }
  }, [data?.repos]);

  const setSections = (
    description,
    blogData,
    cmsData,
    imageData,
    isNormalDrug
  ) => {
    let emptySections = [];
    let sectionList = [...data.sectionList];

    let drugPageMenuList =
      cmsData.drugActive && isNormalDrug
        ? ['Coupon/Prices', 'Price History', 'FAQs', 'News & Research']
        : [];
    if (description && description.length === 0)
      if (_.isEmpty(cmsData))
        emptySections.push(sectionList.indexOf('Overview'));
    if (_.isEmpty(cmsData && cmsData.whatIsUsedFor))
      emptySections.push(sectionList.indexOf('Uses'));
    if (_.isEmpty(cmsData && cmsData.whatFormsDoesDrugComeIn))
      emptySections.push(sectionList.indexOf('Forms'));
    if (_.isEmpty(cmsData && cmsData.howToTakeIt))
      emptySections.push(sectionList.indexOf('Directions'));
    if (_.isEmpty(cmsData && cmsData.whatToDoIfYouMissADose))
      emptySections.push(sectionList.indexOf('Missed a dose'));
    if (_.isEmpty(cmsData && cmsData.contraindications))
      emptySections.push(sectionList.indexOf('Contraindications'));
    if (_.isEmpty(cmsData && cmsData.interactions))
      emptySections.push(sectionList.indexOf('Interactions'));
    if (_.isEmpty(cmsData && cmsData.warnings))
      emptySections.push(sectionList.indexOf('Warnings'));
    if (_.isEmpty(cmsData && cmsData.sideEffects))
      emptySections.push(sectionList.indexOf('Side effects'));
    if (_.isEmpty(cmsData && cmsData.drugPage))
      emptySections.push(sectionList.indexOf('Related drugs'));
    if (_.isEmpty(cmsData && cmsData.relatedConditions))
      emptySections.push(sectionList.indexOf('Related conditions'));
    if (_.isEmpty(blogData))
      emptySections.push(sectionList.indexOf('Research'));
    if (_.isEmpty(imageData)) emptySections.push(sectionList.indexOf('Images'));

    let newSectionList = sectionList.filter(function (value, index) {
      return emptySections.indexOf(index) === -1;
    });
    setData(preData => ({
      ...preData,
      sectionList: newSectionList,
      drugSectionList: drugPageMenuList
    }));
  };

  return (repos && repos.status >= 400) ||
    (repos.drugInformation && repos.drugInformation.drug === undefined) ? (
    <NotFound />
  ) : (
    <main>
      <DrugDetailLayout
        drugName={repos.cmsData.drugName}
        drugInfo={repos.drugInformation}
        sectionList={data.sectionList}
        blogData={repos.blogData}
        imageData={repos.imageData}
        cmsData={repos.cmsData}
        drugSectionList={data.drugSectionList}
        seoName={props.match.params.drugName}
        replaceableVariables={repos.replaceableVariables}
        dosageGuideSlug={repos.cmsData.dosageGuideSlug}
        popularDrugs={repos.popularDrugs?.drugs}
        patientCompassData={repos.patientCompassData}
        isNormalDrug={repos?.drugStructure?.isNormalDrug}
      />
    </main>
  );
};

export default DrugDetail;
